module.exports = __webpack_public_path__ + "media/honey-icons/icon-hub-nano2-97ab849f.svg";